// Dominios viejos de imágenes (Imgix y anteriores). Ya no se usan: sin la firma de Imgix (que
// se pierde al cortar la query) responden 403. El archivo está en el mismo path en files-p,
// igual que lo resuelven picsUrlV2 de api2 y PicsUrl de webroot.
const OLD_IMAGE_HOSTS = [
  "picsv3.pxsol.com",
  "picsv3-b.pxsol.com",
  "images.pxsol.com",
  "picsv2.pxsol.com",
  "pics.pxsol.com",
  "picsold.pxsol.com"
];

export const picsUrl = (url, width, height) => {
  if (!url) return false;

  // Si es una URL de S3 pública, devolverla directamente
  if (url.includes("files-public-web.s3") && url.includes("amazonaws.com")) {
    return url;
  }

  let newUrl = url;
  newUrl = newUrl.replace("files-public-web.s3-us-west-2.amazonaws.com", "files-p.pxsol.com");
  newUrl = newUrl.replace("files-public-web.s3.us-west-2.amazonaws.com", "files-p.pxsol.com");
  newUrl = newUrl.split("?")[0];

  try {
    const parsed = new URL(newUrl);
    if (OLD_IMAGE_HOSTS.includes(parsed.host.toLowerCase())) {
      return `https://files-p.pxsol.com${parsed.pathname}`;
    }
  } catch (e) {
    // URL relativa o inválida: queda como vino.
  }
  return newUrl;
};

export const isEmail = email => {
  return /\S+@\S+\.\S+/.test(email);
};

// El link para compartir sólo se acepta si es https/http y su host es el de la
// página actual o uno de los hosts conocidos del POS (p. ej. PosData.URL).
export const isAllowedShareUrl = (url, extraHosts = []) => {
  try {
    const parsed = new URL(url);
    if (parsed.protocol !== "https:" && parsed.protocol !== "http:")
      return false;
    const normalize = value =>
      String(value || "")
        .trim()
        .toLowerCase()
        .replace(/^https?:\/\//, "")
        .split("/")[0];
    const allowed = [window.location.host, ...extraHosts]
      .map(normalize)
      .filter(Boolean);
    return allowed.indexOf(parsed.host.toLowerCase()) !== -1;
  } catch (e) {
    return false;
  }
};
